import {
  Directive,
  ElementRef,
  HostListener,
  Optional,
  Self
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUppercaseNoAccent]',
  standalone: true,
})
export class UppercaseNoAccentDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  @HostListener('blur')
  onBlur(): void {
    const inputEl = this.el.nativeElement;
    const original = inputEl.value;
    const transformed = this.transformToUppercaseWithoutAccents(original);

    if (original !== transformed) {
      inputEl.value = transformed;

      // Actualiza tambien el valor en el modelo ngModel o FormControl
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(transformed);
      }
    }
  }

  private transformToUppercaseWithoutAccents(value: string): string {
    if (!value) return value;

    return value
      .replace(/ñ/g, '[[enie-min]]')
      .replace(/Ñ/g, '[[enie-may]]')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\[\[enie-min\]\]/g, 'ñ')
      .replace(/\[\[enie-may\]\]/g, 'Ñ')
      .toUpperCase();
  }
}
